import {
  Users,
  UserCog,
  FileSpreadsheet,
  UserPlus,
  Building2,
  Tent,
} from 'lucide-react';

type TimelineItem = {
  id: number;
  title: {
    ar: string;
    en: string;
  };
  startDate: {
    gregorian: string;
  };
  endDate: {
    gregorian: string;
  };
  icon: any;
  color: 'primary' | 'blue' | 'green' | 'yellow' | 'purple' | 'orange';
};

export const timelineData: TimelineItem[] = [
  {
    id: 1,
    title: {
      ar: 'تسجيل المنظمين',
      en: 'Organizer Registration',
    },
    startDate: {
      gregorian: '11/03/2025',
    },
    endDate: {
      gregorian: '13/03/2025',
    },
    icon: Users,
    color: 'primary',
  },
  {
    id: 2,
    title: {
      ar: 'تسجيل المرشدين',
      en: 'Guide Registration',
    },
    startDate: {
      gregorian: '11/03/2025',
    },
    endDate: {
      gregorian: '15/03/2025',
    },
    icon: UserCog,
    color: 'blue',
  },
  {
    id: 3,
    title: {
      ar: 'إسناد الحجاج إلى المرشدين',
      en: 'Assign Pilgrims to Guides',
    },
    startDate: {
      gregorian: '12/03/2025',
    },
    endDate: {
      gregorian: '31/03/2025',
    },
    icon: UserPlus,
    color: 'yellow',
  },
  {
    id: 4,
    title: {
      ar: 'تسكين الحجاج في الفنادق',
      en: 'Hotel Accommodation',
    },
    startDate: {
      gregorian: '31/03/2025',
    },
    endDate: {
      gregorian: '30/04/2025',
    },
    icon: Building2,
    color: 'purple',
  },
  {
    id: 5,
    title: {
      ar: 'تسكين الحجاج في المخيمات',
      en: 'Camp Accommodation',
    },
    startDate: {
      gregorian: '30/04/2025',
    },
    endDate: {
      gregorian: '30/05/2025',
    },
    icon: Tent,
    color: 'orange',
  },
];

export const colorClasses = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-500',
    border: 'border-primary-200',
    timeline: 'bg-primary-500',
  },
  blue: {
    bg: 'bg-blue-50',
    text: 'text-blue-500',
    border: 'border-blue-200',
    timeline: 'bg-blue-500',
  },
  green: {
    bg: 'bg-green-50',
    text: 'text-green-500',
    border: 'border-green-200',
    timeline: 'bg-green-500',
  },
  yellow: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-500',
    border: 'border-yellow-200',
    timeline: 'bg-yellow-500',
  },
  purple: {
    bg: 'bg-purple-50',
    text: 'text-purple-500',
    border: 'border-purple-200',
    timeline: 'bg-purple-500',
  },
  orange: {
    bg: 'bg-orange-50',
    text: 'text-orange-500',
    border: 'border-orange-200',
    timeline: 'bg-orange-500',
  },
};
